import type { AppDispatch } from '../../data/store';
import type { WebSocketSessionInfo } from './webSocketService';
import authService from '../authService';

interface IAuthDetail {
  userAccountID: number;
}

enum AuthEventType {
  UserGlobalSignOut = 'UserGlobalSignOut',
}

/**
 * Method for handling all Auth Events
 * @param sessionInfo The webSocketService sessionInfo object. Contains data copied over from the Redux store as needed
 * @param dispatch The Redux store dispatch function
 * @param detailType A string representing the type of event. Must be one of the AuthEventType enum values
 * @param detail An object containing the event data
 */
function updateAuth(
  sessionInfo: WebSocketSessionInfo,
  dispatch: AppDispatch,
  detailType: string,
  detail: IAuthDetail,
) {
  switch (detailType) {
    case AuthEventType.UserGlobalSignOut:
      if (sessionInfo?.userAccountID === detail.userAccountID) {
        authService.logout().then(() => {
          window.location.href = '/login';
        });
      }
      break;
    default:
      break;
  }
}

export { AuthEventType, updateAuth };
